module.exports = __webpack_public_path__ + "public/images/icon-twitter.90ba917da5b263c8c50c1848c3fe0e24.svg";